<template>
  <sovi-home-card
    src="/images/splash3.webp"
    :title="t('biggerOrganization')"
    class="alt-bg"
    flipped
  >
    <strong>{{ t('businessFeatures') }}</strong>

    <ul class="ms-6 list-disc">
      <li>{{ t('feature1') }}</li>

      <li>{{ t('feature2') }}</li>

      <li>{{ t('feature3') }}</li>

      <li>{{ t('feature4') }}</li>

      <li>{{ t('feature5') }}</li>
    </ul>

    <p>{{ t('contentText') }}</p>
  </sovi-home-card>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>

<style lang="scss"></style>

<i18n lang="json">
{
  "fi": {
    "biggerOrganization": "Palvelun personointi",
    "businessFeatures": "Ota yritystoiminnot käyttöon!",
    "contentText": "Saat yritystoiminnot käyttöön helposti itsepalveluna kun olet kirjautunut sisään. Sovi.fi tarkistaa vahvan tunnistautumisesi perusteella yritysyhteytesi automaattisesti Patentti- ja rekisterihallitukselta. Tämän jälkeen voit aina valita edustatko yritystäsi vai itseäsi yksityishenkilönä, kun luot sopimuksia tai allekirjoitat asiakirjoja.",
    "feature1": "Lähetä asiakirjat yrityksesi nimissä",
    "feature2": "Allekirjoita asiakirjat yrityksesi edustajana",
    "feature3": "Personoi palvelu asiakkaallesi yrityksesi logolla",
    "feature4": "Voit allekirjoittaa ilman vahvaa tunnistautumista",
    "feature5": "Luo omat valmiit sopimuspohjasi",
    "companyName": "Yrityksen nimi",
    "businessId": "Y-tunnus",
    "name": "Hakijan nimi",
    "email": "Hakijan sähköposti",
    "phone": "Hakijan puhelin",
    "submitMessage": "Lähetä",
    "contactUs": "Ota yhteyttä",
    "requiredValue": "Vaadittu tieto",
    "invalidValue": "Virheellinen arvo",
    "requestError": "Hakemus epäonnistui",
    "requestErrorBody": "Yritä myöhemmin uudelleen",
    "requestSuccess": "Hakemus tallennettu",
    "requestSuccessBody": "Vahvistuslinkki on lähetetty antamaasi sähköpostiosoitteeseen."
  },
  "en": {
    "biggerOrganization": "Service personalization",
    "businessFeatures": "Enable business features!",
    "contentText": "You can easily enable business features through self-service when you are logged in. Sovi.fi will automatically check your business connections from the Finnish Patent and Registration Office based on your strong identification. After this, you can always choose whether you represent your company or yourself as a private person when creating contracts or signing documents.",
    "feature1": "Send documents on behalf of your company",
    "feature2": "Sign documents on behalf of your company",
    "feature3": "Personalize the service with your company's logo",
    "feature4": "You can sign documents without strong identification",
    "feature5": "Create re-usable contract templates",
    "companyName": "Company name",
    "businessId": "Business ID",
    "name": "Applicant name",
    "email": "Applicant email",
    "phone": "Applicant phone",
    "submitMessage": "Submit",
    "contactUs": "Contact us",
    "requiredValue": "Required field",
    "invalidValue": "Invalid value",
    "requestError": "Application failed",
    "requestErrorBody": "Try again later",
    "requestSuccess": "Application saved",
    "requestSuccessBody": "The verification link has been sent to the email address you provided."
  }
}
</i18n>
